"use client"

import { create } from 'zustand'

/**
 * Whether the brain dump is open.
 *
 * Capture has several front doors — the button, a keyboard shortcut, the
 * command palette — and they must all lead to the same one. Holding the open
 * state here rather than inside the popover is what lets them.
 */
interface CaptureState {
  isOpen: boolean
  open: () => void
  close: () => void
  setOpen: (open: boolean) => void
}

export const useCaptureStore = create<CaptureState>()((set) => ({
  isOpen: false,
  open: () => set({ isOpen: true }),
  close: () => set({ isOpen: false }),
  setOpen: (isOpen) => set({ isOpen }),
}))
